import { definePolicies } from '@libs/shared/frontend/helpers/define-policies.helper';
import { allPass as rAllPass, prop as rProp, piped as rPiped, constant as rConstant } from 'remeda';

import {
  CampaignRequestStatusEnum,
  OrganizationAccessControlModuleEnum,
  CustomerPermissionActionEnum,
  CustomerPermissionSubjectEnum,
  type components,
} from '@/libs/openapi/schema';
import { hasPermissions, hasModule } from '@/utils/permissions.util';

interface PolicyContext {
  user: components['schemas']['MeResponseDto'];
  organization: components['schemas']['OrganizationResponseDto'] | undefined;
}

export const campaignRequestPolicies = definePolicies((globalCtx: PolicyContext) => ({
  view: rConstant(hasModule(globalCtx.organization, OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
  create: rConstant(rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.CAMPAIGN_REQUEST, [
      CustomerPermissionActionEnum.CREATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
  partialUpdate: rConstant(rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.CAMPAIGN_REQUEST, [
      CustomerPermissionActionEnum.UPDATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
  update: (ctx: components['schemas']['CampaignRequestResponseDto']) => rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.CAMPAIGN_REQUEST, [
      CustomerPermissionActionEnum.UPDATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
    rConstant(
      ctx.status === CampaignRequestStatusEnum.DRAFT ||
      (ctx.status === CampaignRequestStatusEnum.IN_REVIEW && ctx.createdByApiKey == null),
    ),
  ]),
  archive: (ctx: components['schemas']['CampaignRequestResponseDto']) => rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.CAMPAIGN_REQUEST, [
      CustomerPermissionActionEnum.UPDATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
    rConstant(ctx.archivedAt == null),
    rConstant(
      ctx.status === CampaignRequestStatusEnum.DRAFT ||
      ctx.status === CampaignRequestStatusEnum.DECLINED ||
      ctx.status === CampaignRequestStatusEnum.COMPLETED ||
      ctx.status === CampaignRequestStatusEnum.ENDED,
    ),
  ]),
  unarchive: (ctx: Pick<components['schemas']['CampaignRequestResponseDto'], 'archivedAt'>) => rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.CAMPAIGN_REQUEST, [
      CustomerPermissionActionEnum.UPDATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
    rConstant(ctx.archivedAt != null),
  ]),
}));
